import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=67dd48c9&"
import script from "./shipping.vue?vue&type=script&lang=js&"
export * from "./shipping.vue?vue&type=script&lang=js&"
import style0 from "./shipping.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports